import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  Modal, ModalHeader, ModalBody, ModalFooter,
  Button, Badge
} from 'reactstrap'
import moment from 'moment'
import { getLegalSolicitationResponses } from '../../../../store/ducks/management'
import oikosApi from '../../../../services/oikos'
import { getOikosFileUrl } from '../../../../utils/linksOikos/link'

const openAnexo = (e, caminho) => {
  e.preventDefault()
  e.stopPropagation()
  const url = getOikosFileUrl(caminho)
  if (url) window.open(url, '_blank', 'noopener,noreferrer')
}

const collectAnexoItems = (anexoColumn, arquivoRows = []) => {
  const items = []
  const seen = new Set()
  const push = (path, label) => {
    if (!path) return
    const key = String(path)
    if (seen.has(key)) return
    seen.add(key)
    items.push({ path: key, label: label || String(path).split('/').pop() })
  }
  push(anexoColumn)
  ;(Array.isArray(arquivoRows) ? arquivoRows : []).forEach((row) => {
    if (row && row.arquivo_caminho) {
      push(row.arquivo_caminho, row.arquivo_desc)
    }
  })
  return items
}

const fetchArquivosByTab = async (arquivo_tabRef, arquivo_tabId) => {
  if (!arquivo_tabId) return []
  try {
    const res = await oikosApi.post('/', {
      action: 'get',
      table: 'arquivo',
      data: { arquivo_tabRef, arquivo_tabId },
    })
    const rows = Array.isArray(res.data) ? res.data : []
    return rows.filter(r => r && (r.arquivo_ativo === undefined || Number(r.arquivo_ativo) !== 0))
  } catch (err) {
    console.error('Erro ao buscar arquivos:', err)
    return []
  }
}

class ProjLegalDetailsModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      solicitationArquivos: [],
      responseArquivosById: {},
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.isOpen && !prevProps.isOpen) {
      if (this.props.solicitation) {
        const sid = this.props.solicitation.id || this.props.solicitation.solicitacoes_juridicas_id
        this.props.getLegalSolicitationResponses(sid)
        this.loadSolicitationArquivos(sid)
        this.setState({ responseArquivosById: {} })
      }
    }

    if (!this.props.isOpen && prevProps.isOpen) {
      this.setState({ solicitationArquivos: [], responseArquivosById: {} })
    }

    const prev = prevProps.legalSolicitationResponses
    const curr = this.props.legalSolicitationResponses
    if (this.props.isOpen && curr !== prev && Array.isArray(curr)) {
      this.loadResponseArquivos(curr)
    }
  }

  loadSolicitationArquivos = async (solicitacaoId) => {
    const rows = await fetchArquivosByTab('solicitacoes_juridicas', solicitacaoId)
    this.setState({ solicitationArquivos: rows })
  }

  loadResponseArquivos = async (responses) => {
    const list = Array.isArray(responses) ? responses : []
    const entries = await Promise.all(list.map(async (res) => {
      const rid = res.id || res.solicitacoes_juridicas_respostas_id
      const rows = await fetchArquivosByTab('solicitacoes_juridicas_respostas', rid)
      return [String(rid), rows]
    }))
    const responseArquivosById = {}
    entries.forEach(([id, rows]) => { responseArquivosById[id] = rows })
    this.setState({ responseArquivosById })
  }

  renderAnexoLinks = (items, { outline = false } = {}) => {
    if (!items || !items.length) return null
    return (
      <div style={{ marginTop: outline ? '10px' : 0, display: 'flex', flexDirection: 'column', gap: 6 }}>
        {items.map(item => (
          outline ? (
            <Button
              key={item.path}
              color="primary"
              size="sm"
              outline
              onClick={e => openAnexo(e, item.path)}
              style={{ alignSelf: 'flex-start' }}
            >
              <i className="ri-attachment-line" /> {item.label || 'Anexo'}
            </Button>
          ) : (
            <Button
              key={item.path}
              color="link"
              size="sm"
              className="p-0"
              style={{ fontSize: '13px', alignSelf: 'flex-start' }}
              onClick={e => openAnexo(e, item.path)}
            >
              <i className="ri-attachment-line" /> {item.label || 'Anexo'}
            </Button>
          )
        ))}
      </div>
    )
  }

  render() {
    const {
      isOpen, toggle, solicitation, pfList,
      formatProjSolicitationStatus, getProjContractLabel,
      getLegalSolicitationResponsesIsLoading,
      legalSolicitationResponses,
    } = this.props
    const { solicitationArquivos, responseArquivosById } = this.state

    const latestStatus = legalSolicitationResponses?.slice().reverse().find(r => r.status_alterado_para)?.status_alterado_para || solicitation?.status

    return (
      <Modal centered isOpen={isOpen} toggle={toggle} size="lg" enforceFocus={false}>
        <ModalHeader toggle={toggle}>
          Detalhes do Chamado: {solicitation?.tipo_assunto || '—'}
        </ModalHeader>
        <ModalBody style={{ maxHeight: '75vh', overflowY: 'auto' }}>
          {solicitation && (
            <div style={{ padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '8px', border: '1px solid #e9ecef' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '15px' }}>
                <div>
                  <span style={{ fontSize: '12px', color: '#6c757d', display: 'block' }}>Solicitante</span>
                  <strong style={{ fontSize: '14px', color: '#495057' }}>{solicitation.solicitante || '—'}</strong>
                </div>
                <div>
                  <span style={{ fontSize: '12px', color: '#6c757d', display: 'block' }}>Data</span>
                  <strong style={{ fontSize: '14px', color: '#495057' }}>
                    {solicitation.data_criacao ? moment(solicitation.data_criacao).format('DD/MM/YYYY') : '—'}
                  </strong>
                </div>
                <div>
                  <span style={{ fontSize: '12px', color: '#6c757d', display: 'block' }}>Prazo</span>
                  <strong style={{ fontSize: '14px', color: '#495057' }}>
                    {solicitation.prazo_atendimento ? moment(solicitation.prazo_atendimento).format('DD/MM/YYYY') : '—'}
                  </strong>
                </div>
                <div>
                  <span style={{ fontSize: '12px', color: '#6c757d', display: 'block' }}>Status</span>
                  {formatProjSolicitationStatus({ ...solicitation, status: latestStatus })}
                </div>
              </div>

              {solicitation.contrato_id && (
                <div style={{ marginBottom: '10px', fontSize: '13px' }}>
                  <strong>Contrato:</strong> {getProjContractLabel()}
                </div>
              )}
              <div style={{ padding: '10px', backgroundColor: '#f1f5f7', borderRadius: '4px', fontSize: '14px' }} dangerouslySetInnerHTML={{ __html: solicitation.teor }} />
              {(() => {
                const items = collectAnexoItems(solicitation.anexo, solicitationArquivos)
                if (!items.length) return null
                return (
                  <div style={{ marginTop: '10px' }}>
                    <div style={{ fontSize: 12, color: '#6c757d', marginBottom: 4 }}>Anexo original da solicitação</div>
                    {this.renderAnexoLinks(items, { outline: true })}
                  </div>
                )
              })()}
            </div>
          )}

          <h5 className="mt-4 mb-3" style={{ fontSize: '15px', fontWeight: 'bold', color: '#495057' }}>Histórico de Respostas</h5>

          {getLegalSolicitationResponsesIsLoading ? (
            <div className="text-center my-4"><div className="spinner-border text-primary" role="status" /></div>
          ) : (
            <div>
              {legalSolicitationResponses?.length > 0 ? (
                legalSolicitationResponses.map(res => (
                  <div key={res.id || res.solicitacoes_juridicas_respostas_id} style={{ padding: '12px', backgroundColor: '#fff', borderRadius: '8px', marginBottom: '10px', border: '1px solid #e9ecef' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px', fontSize: '12px' }}>
                      <strong>{res.autor_id ? (pfList?.find(p => String(p.pf_id) === String(res.autor_id))?.pf_nome || `Autor ID: ${res.autor_id}`) : 'Jurídico/Sistema'}</strong>
                      <span className="text-muted">{moment(res.data_criacao).format('DD/MM/YYYY HH:mm')}</span>
                    </div>
                    <div style={{ fontSize: '14px', color: '#333' }} dangerouslySetInnerHTML={{ __html: res.teor }} />

                    <div style={{ marginTop: '8px', display: 'flex', flexDirection: 'column', gap: 6 }}>
                      {res.status_alterado_para && (
                        <Badge color="light" style={{ border: '1px solid #ddd', color: '#555', alignSelf: 'flex-start' }}>
                          Status alterado para: {res.status_alterado_para}
                        </Badge>
                      )}
                      {(() => {
                        const rid = res.id || res.solicitacoes_juridicas_respostas_id
                        const items = collectAnexoItems(res.anexo, responseArquivosById[String(rid)])
                        if (!items.length) return null
                        return (
                          <div>
                            <div style={{ fontSize: 12, color: '#6c757d', marginBottom: 4 }}>Anexos desta resposta</div>
                            {this.renderAnexoLinks(items)}
                          </div>
                        )
                      })()}
                    </div>
                  </div>
                ))
              ) : (
                <p className="text-muted" style={{ fontSize: '13px' }}>Nenhuma resposta registrada ainda.</p>
              )}
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <Button
            type="button"
            onClick={toggle}
            color="light"
            className="waves-effect"
          >
            Fechar
          </Button>
        </ModalFooter>
      </Modal>
    )
  }
}

const mapStateToProps = state => ({
  getLegalSolicitationResponsesIsLoading: state.management.getLegalSolicitationResponsesIsLoading,
  legalSolicitationResponses: state.management.legalSolicitationResponses,
})

const mapDispatchToProps = dispatch => bindActionCreators({
  getLegalSolicitationResponses,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(ProjLegalDetailsModal)
